<template>
  <div id="page-user-edit">

    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="user_data">

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab v-if="$acl.check('manager') && this.profileType !== '1'" label="Personal" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <edit-tab-staff-account  class="mt-4" :data="user_data" />
            </div>
          </vs-tab>
          <vs-tab v-if="$acl.check('admin') && this.profileType !== '1'" label="Administrador" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <edit-tab-admin-account class="mt-4" :data="user_data" />
            </div>
          </vs-tab>
          <vs-tab v-if="this.profileType === '1'" label="Acudiente" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <edit-tab-parent-account class="mt-4" :data="user_data" />
            </div>
          </vs-tab>
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import EditTabStaffAccount     from "./EditTabStaffAccount.vue"
import EditTabAdminAccount     from "./EditTabAdminAccount.vue"
import EditTabParentAccount from "./EditTabParentAccount.vue";

// Store Module
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  components: {
    EditTabStaffAccount,
    EditTabAdminAccount,
    EditTabParentAccount,
  },
  data() {
    return {
      user_data: null,
      user_not_found: false,
      activeTab: 0,
    }
  },
  watch: {
    activeTab() {
      this.fetch_user_data(this.$route.params.userId, this.$route.query.profileType)
    }
  },
  methods: {
    fetch_user_data(userId, profileType = null) {
      if (profileType === "1") {
        this.user_data = this.$store.state.userManagement.parents.find(u => u.id == userId);
      } else {
        if(this.$acl.check('admin'))
          this.user_data = this.$store.state.userManagement.owners.find(u => u.id == userId);
  
        if(this.$acl.check('manager'))
          this.user_data = this.$store.state.userManagement.users.find(u => u.id == userId);
      }
    },
  },
  created() {
    this.profileType = this.$route.query.profileType
    if(!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }

    this.fetch_user_data(this.$route.params.userId, this.$route.query.profileType)
  }
}

</script>
